import { Control, UseFormSetValue } from 'react-hook-form'

import { Input } from '@/components/ui'
import FormGroup from '@/core/components/FormGroup'
import { HtmlEditor } from '@/core/components/HtmlEditor'

import { IArtistValues } from './types'

export const ArtistLanguageCard = ({
  languageName,
  index,
  control,
  setValue,
  value,
  isError,
}: {
  languageName: string
  index: number
  control: Control<IArtistValues>
  setValue: UseFormSetValue<IArtistValues>
  value: string
  isError: boolean
}) => (
  <div className="flex w-full flex-col gap-[25px] rounded-[30px] bg-monochrome-120 p-5">
    <FormGroup label="Language">
      <Input value={languageName} readOnly />
    </FormGroup>
    <HtmlEditor
      index={index}
      label="Description (Optional)"
      name={`content.${index}.description`}
      variables={[]}
      control={control}
      value={value}
      onChange={(data) => setValue(`content.${index}.description`, data)}
      isError={isError}
      checkboxLabel="Custom HTML"
      checkboxWrapperClassName="mt-0"
    />
  </div>
)
